import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import { useEffect, useState } from "react";
export const dropdownMenu = tailwindVariants({
    base: "z-portal flex max-h-[var(--radix-dropdown-menu-content-available-height)] w-[216px] min-w-[var(--radix-popper-anchor-width)] flex-col gap-2 overflow-y-auto rounded bg-surface-1 p-2 text-grey-12 shadow-popover outline-none radix-side-bottom:animate-slide-up radix-side-top:animate-slide-down dark:border dark:border-grey-5",
    variants: {
        size: {
            small: "w-[216px]",
            large: "w-[240px]"
        }
    },
    defaultVariants: {
        size: "small"
    }
});
export const DropdownMenu = (param)=>{
    let { align = "start", alignOffset, children, className, collisionPadding = 8, disabled, loop, onOpenChange, open = false, side = "bottom", sideOffset = 8, size = "small", trigger, container, onEscapeKeyDown, ...restOfProps } = param;
    const [isMenuOpened, setIsMenuOpened] = useState(open);
    useEffect(()=>{
        setIsMenuOpened(open);
    }, [
        open
    ]);
    return /*#__PURE__*/ _jsxs(RadixDropdownMenu.Root, {
        "data-theme": "dark",
        dir: "ltr",
        modal: false,
        onOpenChange: (open)=>{
            setIsMenuOpened(open);
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
        },
        open: isMenuOpened,
        children: [
            /*#__PURE__*/ _jsx(RadixDropdownMenu.Trigger, {
                asChild: true,
                disabled: disabled,
                children: trigger
            }),
            /*#__PURE__*/ _jsx(RadixDropdownMenu.Portal, {
                container: container,
                children: /*#__PURE__*/ _jsx(RadixDropdownMenu.Content, {
                    align: align,
                    alignOffset: alignOffset,
                    className: dropdownMenu({
                        size,
                        className
                    }),
                    collisionPadding: collisionPadding,
                    "data-testid": "DROPDOWN_MENU",
                    loop: loop,
                    side: side,
                    sideOffset: sideOffset,
                    onEscapeKeyDown: onEscapeKeyDown,
                    ...restOfProps,
                    children: children
                })
            })
        ]
    });
};
